import React from 'react';
import { View, Text, TouchableOpacity, Modal, StyleSheet, Platform } from 'react-native';
import LinearGradient from '../../../../components/LinearGradient';
import { X } from '../../../../components/Icons';
import { useRemScale } from '../../../../lib/remScale';

// CSS blur for web
const webBlurStyle = Platform.OS === 'web' ? {
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
} : {};

/**
 * Teleport Confirmation Modal - confirms teleport to Quikbase
 */
export default function TeleportConfirmModal({ visible, onClose, onConfirm }) {
  const { rem } = useRemScale();

  return (
    <Modal
      transparent
      visible={visible}
      animationType="fade"
      onRequestClose={onClose}
      supportedOrientations={['portrait', 'portrait-upside-down', 'landscape', 'landscape-left', 'landscape-right']}
    >
      <View style={styles.full} pointerEvents="box-none">
        {/* Blurred overlay background */}
        <View 
          style={[StyleSheet.absoluteFillObject, { backgroundColor: 'rgba(0,0,0,0.7)', ...webBlurStyle }]} 
        />
        <TouchableOpacity style={StyleSheet.absoluteFillObject} activeOpacity={1} onPress={onClose} />

        <View style={[styles.card, { width: rem(280), borderRadius: rem(16), padding: rem(16) }]}>
          <TouchableOpacity
            onPress={onClose}
            style={{
              position: 'absolute',
              right: rem(12),
              top: rem(12),
              width: rem(32),
              height: rem(32),
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0.7,
            }}
            hitSlop={{ top: 16, bottom: 16, left: 16, right: 16 }}
            accessibilityLabel="Close"
          >
            <X size={rem(16)} color="#fff" />
          </TouchableOpacity>

          <Text style={[styles.title, { fontSize: rem(18), marginBottom: rem(8) }]}>Confirm Teleport</Text>
          <Text style={[styles.message, { fontSize: rem(14), marginBottom: rem(16) }]}>
            Are you sure you want to teleport to Quikbase?
          </Text>

          <View style={{ gap: rem(12) }}>
            <TouchableOpacity
              activeOpacity={0.9}
              onPress={() => {
                if (onConfirm) onConfirm();
              }}
              style={{ height: rem(48), borderRadius: rem(12), overflow: 'hidden' }}
            >
              <LinearGradient
                colors={['#C5E836', '#84cc16']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={{
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Text style={[styles.buttonText, { color: '#000', fontSize: rem(14) }]}>Yes, Teleport</Text>
              </LinearGradient>
            </TouchableOpacity>

            <TouchableOpacity
              activeOpacity={0.9}
              onPress={onClose}
              style={{
                height: rem(48),
                borderRadius: rem(12),
                backgroundColor: 'rgba(255,255,255,0.10)',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text style={[styles.buttonText, { color: '#fff', fontSize: rem(14) }]}>Cancel</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  full: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 1000,
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    backgroundColor: '#111216',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.10)',
    shadowColor: '#000',
    shadowOpacity: 0.6,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 12 },
  },
  title: {
    color: '#fff',
    fontWeight: '700',
    textAlign: 'center',
  },
  message: {
    color: 'rgba(255,255,255,0.70)',
    textAlign: 'center',
  },
  buttonText: {
    fontWeight: '700',
  },
});
